<template>
    <div class="wrapper">
        <div class="use">
			<!-- 以后可能有业务不显示云之谷logo，或更换成其他的logo -->
            <!-- <div class="content" :style="{'background':getBackground}"> -->
			<div class="content">
                <span class="logo">
					<!-- 右上角logo，以后可能有业务不显示云之谷logo，或更换成其他的logo -->
                    <img src="../assets/logo.png" alt="logo">
                </span>
                <div class="head">
                    <header></header>
                    <span class="title">{{name}}</span>
                </div>
                <div class="body">
                    <div class="code">
                        <div class="tip">券码有效期至{{expiredDate}},请您尽快完成券码使用,券码超过有效期未使用,服务商无法为您提供换券服务。</div>
                        <div class="qrcode" ref="qrCodeUrl"></div>
                    </div>
                    <div class="sec">请出示以上券码给门店工作人员</div>
                </div>
                <div class="foot">
                    <h1>券码规则</h1>
                    <div v-html="regulation" class="tip"></div>
                    <!-- <p>1.电子券可叠加使用,一次可使用多张代券。</p>
                    <p>2.不得与其他优惠同时使用,不适用于外卖。</p>
                    <p>3.电子券不找零、不兑现,消费金额超过券面,部分的金额请通过奈雪的茶支持的支付方式</p>
                    <p>4.使用时段以门店具体营业时间为准</p>
                    <p>5.请妥善保管接收到的电子码信息,只能验证,消费一次,一经售出不予退换。</p>
                    <p>6.奈雪的茶将不会对本券消费的金额开具发，敬请谅解</p>
                    <p>7.电子券一经售出不可二次转售，一经发现封锁券码</p>
                    <p>8.图片仅供示意，并不代表实际交付的商品内容，本券实际可抵用金额、使用限制条件以券码面值及其他说明为准。</p>
                    <p>客服热线</p>
                    <p>如在购买过程中有任何问题,由杭州云之谷网络科技有限公司负责,请拨打客服热线:</p>
                    <p>0571-85199986</p> -->
                </div>
            </div>
        </div>
        <div class="use_loading" v-if="loading">
            <div class="loading">
                <img src="../assets/loading.png" alt="加载中">
            </div>
        </div>
    </div>
</template>
<script>
import QRCode from 'qrcodejs2'; //引入生成二维码插件
import JsBarcode from 'jsbarcode';
// var JsBarcode = require('jsbarcode');
export default {
    data(){
        return{
            loading:true,
            key:this.$route.query.key,
            mobile: this.$route.query.mobile,
            name:'',
            effectiveDate:'',
            expiredDate:'',
            ticket:{},
            regulation: '',
   //          used:false,
			// 默认有背景logo
			// getBackground: 'url:\'../assets/code_bg.png\' #fff center 20px no-repeat'
        }
    },
    mounted(){
        this.getTicket();
        // this.creatQrCode(this.key);
    },
    methods:{
        creatQrCode(val) {
            let qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: val,
                width: 178,
                height: 178,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            });
            this.loading = false;
        },
        getTicket(){
            const obj = {
                ticketNo:this.key,
                isVerify:'-1',
                mobile:this.mobile
            };
            this.$http.POST('productTicket/selectProductTicket',obj).then(res=>{
                // this.loading = false;
                if(res.code===0){
                    // name:this.$route.query.name,
                    // effectiveDate:this.$route.query.effectiveDate,
                    // expiredDate:this.$route.query.expiredDate,
                    // status:this.$route.query.status,
                    this.ticket = res.data;
                    this.name = this.ticket.ticketName;
                    this.effectiveDate = this.ticket.effectiveDate;
                    this.expiredDate = this.ticket.expiredDate;
                    this.regulation = this.ticket.regulation;
                    this.creatQrCode(this.ticket.outTicketPsw);
					// 以后可能需要不显示背景logo，判断条件到时候更换成后台返回的值去判断
					// if(this.used){
					// 	this.getStyle='#fff center 20px no-repeat';
					// }
                } else {
                    alert(res.msg);
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.wrapper{
    height: 100%;
    position: relative;
    .use{
        // height: 100%;
        background: #108EE9;
        padding: 30px 15px 15px 15px;
        box-sizing: border-box;
        min-height:100%;
        .content{
            background: #fff;
            border-radius: 4px;
            background: url('../assets/code_bg.png') #fff center 20px no-repeat;
            background-size: 305px 338px;
            min-height: 338px;
            position: relative;
            .logo{
                position: absolute;
                display: inline-block;
                right: 0;
                top: 0;
                img{
                    width: 51px;
                    height: 51px;
                }
            }
            .head{
                position: relative;
                height: 30px;
                width: 100%;
                display: flex;
                justify-content: center;
                header{
                    width: 190px;
                    border-top: 30px solid #2C78DC;
                    border-right: 12px solid transparent;
                    border-left:12px solid transparent;
                    box-sizing: border-box;
                    height: 30px;
                }
                .title{
                    font-size: 15px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    color: #fff;
                    width: 100%;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                }
            }
            .body{
                border-bottom:1px dashed #CCCCCC;
                p{
                    font-size: 15px;
                    color: #999999;
                    text-align: center;
                    padding-top: 10px;
                }
                h1{
                    font-size: 20px;
                    color: #333333;
                    text-align: center;
                    padding-top: 15px;
                }
                .code{
                    padding-top: 40px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    .qrcode{
                        padding-top: 20px;
                    }
                    .tip{
                        width:75%;
                        background:yellow;
                        font-size:12px;
                    }
                }
                .sec{
                    font-size: 15px;
                    color: #999999;
                    padding: 30px 0 15px 0;
                    text-align: center;
                }
                .dec{
                    font-size: 15px;
                    background: #FEFCEC;
                    padding: 10px 0;
                    color: #F76A24;
                    text-align: center;
                }
                .btn{
                    display: flex;
                    justify-content: center;
                    padding: 15px 0 30px 0;
                    .button{
                        font-size: 15px;
                        width: 200px;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        color: #fff;
                        background: #1E87FC;
                        border-radius: 4px;
                    }
                }
            }
            .foot{
                padding: 24px 17px;
                h1{
                    font-size: 20px;
                    color: #333333;
                    font-weight: bold;
                }
                .tip{
                    color: #666666;
                    font-size: 15px;
                    line-height: 28px;
                }
            }
        }
    }
    
    .use_loading{
        position: absolute;
        height: 100%;
        width: 100%;
        z-index: 11;
        left: 0;
        top: 0;
        .loading{
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            img{
                width:50px;
                height: 50px;
                animation:turn .8s linear infinite;      
                margin: 100px auto;
            }
            @keyframes turn{
                0%{-webkit-transform:rotate(0deg);}
                25%{-webkit-transform:rotate(90deg);}
                50%{-webkit-transform:rotate(180deg);}
                75%{-webkit-transform:rotate(270deg);}
                100%{-webkit-transform:rotate(360deg);}
            }
        }
    } 
}
</style>